export const supportedFileFormats = [
  'pdf',
  'tiff',
  'jpg',
  'jpeg',
  'png',
  'heic',
  'heif',
]
